// extracted by mini-css-extract-plugin
export var primitiveLabel = "_to-0";